export default "__VITE_ASSET__CA0yCzIQ__"